// clear.meta-reducer.ts
import { ActionReducer } from '@ngrx/store';
import { CLEAR } from '../actions/clear.action';
import { IAppState } from '../interfaces/app-state.interface';

export const clearMetaReducer =
  (reducer: ActionReducer<IAppState>): ActionReducer<IAppState> =>
  (state, action) => {
    if (action.type === CLEAR) {
      localStorage.removeItem('state');
      return reducer(action.type === CLEAR ? undefined : state, action);
    }
    return reducer(state, action);
  };
